import { Box } from '@mui/material';
import {
  ResponseDataHandle,
  ListPlaceholder,
  ErrorList,
  EmptyData,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { Customer } from '@/@types/customer';
import { CustomersTable } from '../CustomersTable';
import { CustomersTableColumns } from '../CustomersTable/CustomerTableColumns';

type TCustomersData = {
  customers: Customer[];
  totalCount: number;
};

interface ICustomersListProps {
  isLoading: boolean;
  isError: boolean;
  data: TCustomersData | undefined;
  sort?: 'desc' | 'asc';
  sortBy?: keyof Customer;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function CustomersList({
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: ICustomersListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder
          headers={[
            'Nome',
            'CPF/CNPJ',
            'RG/Inscrição Estadual',
            'Criado em',
            'Ações',
          ]}
        />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Falha ao obter os dados dos clientes." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <CustomersTable
        columns={CustomersTableColumns}
        data={data?.customers || []}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        actions={actions}
        pagination={pagination}
      />
    </ResponseDataHandle>
  );
}
